import type { FeedComment } from "../types/feed.ts"

export function pickPostCommentsFromApi(raw: object): FeedComment[] {
  const r = raw as Record<string, unknown>
  const asList = (x: unknown): FeedComment[] =>
    Array.isArray(x) ? (x as FeedComment[]) : []
  const direct = asList(r.comments)
  if (direct.length > 0) return direct
  const latestSnake = asList(r.latest_comments)
  if (latestSnake.length > 0) return latestSnake
  return asList(r.latestComments)
}
